import { render, staticRenderFns } from "./oembed_preview.vue?vue&type=template&id=60b240dd&"
import script from "./oembed_preview.vue?vue&type=script&lang=js&"
export * from "./oembed_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports